<template>
    <div class="card bg-dark text-white border-0">
        <img class="card-img" src="img/custom/brochure_small_widget.png" alt="Card image" style="height: 140px;">
        <div class="card-img-overlay d-flex align-items-center">
            <div>
                <h5 class="h2 card-title text-white mb-2">Our Brochure</h5>
                <p class="card-text text-sm font-weight-bold"><a href="#!" @click="retrieveDocument('brochure')"
                        class="btn btn-sm btn-white">download</a></p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment'

import ApiMixin from '@/plugins/apiMixin';

export default {
  mixins: [ApiMixin.Mixin],
    name: "promotion-tips-small",
    components: {
    },
    data() {
        return {
            loading: false,
            currentBook: [],
            document: [],
        };
    },
    props: {
        photoBookId: '',
        hasQrCode: false,
    },
    methods: {
        retrieveDocument(docname) {
            this.loading = true;
            this.$api.getDocument(docname)
                .then((response) => {
                    this.document = response.data;
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false;
                    return this.retrieveDocumentFile(docname);
                });
        },
        retrieveDocumentFile(docname) {
            this.loading = true;
            this.$api.getDocumentFile(docname)
                .then((response) => {
                    this.forceFileDownload(response, this.document.filename);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false
                });
        },
        forceFileDownload(response, title) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', title)
            document.body.appendChild(link)
            link.click()
        },
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount' }),
    },
    mounted() {
       // this.retrieveDocument();
    },
};
</script>
<style scoped>
.card-body {
    padding: 0px !important;
}
</style>